import React from 'react';
import './Features.css'; // ייבוא קובץ העיצוב




export default function Features() {
  // מערך הנתונים המאפשר לשנות או להוסיף פריטים בקלות
  const featuresData = [
    {
      id: 1,
    title: 'שירות אישי לכל לקוח',
      imageSrc: '/img4.png', 
    },
    {
      id: 2,
        title: 'מעל 10 שנות ניסיון',
      imageSrc: '/img5.png', 
    },
    {
      id: 3,
      title: '100% מקצוענות',
      imageSrc: '/img6.png', 
    },
    {
      title: 'אוטם מורשה',
      // כאן תוכל להחליף את ה-src בנתיב ללוגו/תמונה שלך בעתיד
      imageSrc: '/img7.png', 
    },
  ];

  return (
    <section className="features-section" dir="rtl">
      <div className="features-container">
        {featuresData.map((item) => (
          <div key={item.id} className="feature-item">
            {/* מבנה הגג והלוגו */}
            <div className="feature-icon-wrapper">
              <span className="roof-line"></span>
              <img 
                src={item.imageSrc} 
                alt={item.title} 
                className="feature-image" 
              />
            </div>
            
            {/* הטקסט מתחת לכל לוגו */}
            <h3 className="feature-text">{item.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
}
